/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { UseNavigationIconDirective } from '@ui-components/atoms/icons/navigation.directive';
import { AvatarDirective } from '@ui-components/molecules/avatar.directive';
import {
  NavSectionDirective,
  NavSectionStatusVariant,
} from '@ui-components/organisms/nav-section.directive';
import * as fromLayout from '..';
import * as fromAuth from '../../auth';

@Component({
  selector: 'dmcom-sidebar-mobile',
  imports: [
    AvatarDirective,
    NavSectionDirective,
    UseNavigationIconDirective,
    TranslateModule,
  ],
  template: `
    <div
      #sidenav
      class="p-20 bg-gradient-b-diagonal flex flex-col items-start fixed inset-0 z-50 transition-transform duration-500 w-5/6"
      [class.-translate-x-full]="!isSideContainerOpened()"
      [class.translate-x-0]="isSideContainerOpened()"
    >
      <div class="w-full mt-auto mb-1 p-20 flex flex-col gap-6 justify-between">
        <div class="w-full flex items-center gap-6 justify-between">
          <div class="flex items-center gap-4 min-w-0">
            <div dmcomAvatar size="md">
              {{ userInitials() }}
            </div>
            <div
              class="text-p2 text-neutral-50 whitespace-nowrap overflow-hidden text-ellipsis"
            >
              {{ userName() }}
            </div>
          </div>
          <a dmcomNavSection status="default" (click)="handleClickLogoutCTA()">
            <svg dmcomUseNavigationIcon="logout"></svg>
          </a>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
      }
    `,
  ],
})
export class SidebarMobileResponsive {
  readonly sidenav = viewChild.required<ElementRef>('sidenav');

  private readonly layoutStore = inject<Store<fromLayout.LayoutState>>(Store);
  private readonly authStore = inject<Store<fromAuth.AuthState>>(Store);
  private readonly router = inject(Router);
  public readonly userInitials = input.required<string>();
  public readonly userName = input.required<string>();
  public readonly isSideContainerOpened = this.layoutStore.selectSignal(
    fromLayout.layoutFeature.selectIsSidebarOpened,
  );

  public handleClickLogoutCTA() {
    this.authStore.dispatch(fromAuth.AuthActions.logout());
  }

  public getNavStatus(route: string): NavSectionStatusVariant {
    return this.router.url === route
      ? NavSectionStatusVariant.selected
      : NavSectionStatusVariant.default;
  }

  public toggleSideContainer() {
    if (this.isSideContainerOpened()) {
      this.layoutStore.dispatch(
        fromLayout.LayoutActions.setSidebarOpened({ isOpened: false }),
      );
    } else {
      this.layoutStore.dispatch(
        fromLayout.LayoutActions.setSidebarOpened({ isOpened: true }),
      );
    }
  }

  @HostBinding('class') get isSideContainerClosed() {
    return this.isSideContainerOpened()
      ? '@apply block h-svh w-screen absolute z-50 bg-transparency-black-24'
      : '';
  }

  @HostListener('click', ['$event']) onClickOutsideCloseSideContainer(
    event: Event,
  ) {
    if (
      this.isSideContainerOpened() &&
      !this.sidenav().nativeElement.contains(event.target)
    ) {
      this.layoutStore.dispatch(
        fromLayout.LayoutActions.setSidebarOpened({ isOpened: false }),
      );
    }
  }
}
